import { BackendInterface, DataResponse } from "@imagine/frontend-base";
import { KeyPage, Page, PageConverter } from "..";

const getPageContent = async (
  backend: BackendInterface,
  language: string,
  url: string,
) => {
  let path = language;
  if (url !== "") path += "/" + url;
  const result = await backend.get("api/page/" + path);
  const response: DataResponse<Page> = {
    success: result.success,
    data: undefined,
  };

  if (result.success) {
    try {
      response.data = result.data as Page;
    } catch (e) {
      backend.captureException("Failed to parse page content", {
        Path: path,
        Result: JSON.stringify(result),
      });
    }
  } else {
    backend.captureException("Failed to get page content", {
      Path: path,
      Result: JSON.stringify(result),
    });
  }
  return response;
};

const getPages = async (backend: BackendInterface) => {
  const result = await backend.post("api/pages/filter", {});
  const response: DataResponse<Page[]> = {
    success: result.success,
  };

  if (result.success && result.data) {
    try {
      response.data = result.data as Page[];
    } catch (e) {
      backend.captureException("Failed to parse pages", {
        Result: JSON.stringify(result),
      });
    }
  } else {
    backend.captureException("Failed to get pages", {
      Result: JSON.stringify(result),
    });
  }
  return response;
};

const getKeyPages = async (backend: BackendInterface) => {
  const result = await backend.get("api/pages/key-pages");
  const response: DataResponse<KeyPage[]> = {
    success: result.success,
  };

  if (result.success && result.data) {
    try {
      response.data = PageConverter.getKeyPages(result.data as Page[]);
    } catch (e) {
      backend.captureException("Failed to parse key pages", {
        Result: JSON.stringify(result),
      });
    }
  } else {
    backend.captureException("Failed to get key pages", {
      Result: JSON.stringify(result),
    });
  }
  return response;
};

const getPage = async (backend: BackendInterface, pageId: number) => {
  const result = await backend.get("api/pages/id/" + pageId);
  const response: DataResponse<Page> = {
    success: result.success,
  };

  if (result.success && result.data) {
    try {
      response.data = {
        ...result.data,
        content: JSON.parse(result.data.content),
      };
      // response.data = result.data as Page;
    } catch (e) {
      backend.captureException("Failed to parse page", {
        Result: JSON.stringify(result),
      });
    }
  } else {
    backend.captureException("Failed to get page", {
      Result: JSON.stringify(result),
    });
  }
  return response;
};

export const PagesApi = {
  getPageContent,
  getPages,
  getKeyPages,
  getPage,
};
